<template>
  <!-- 成功导入msg复用此结构 加class t-success -->
  <div v-if="show" class="message-wrap isShow" :class="[messageType === 'success' ? 't-success' : '']">
    <!-- 提示icon  -->
    <img :src="imgObj[messageType]" alt="" class="message-wrap-icon" />
    <p class="message-wrap-bd">
      {{ content }}
    </p>
    <div class="message-wrap-ft" v-show="messageType === 'warn'" @click="$emit('pauseNow')">立即暂停</div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isNeedAutoDisappear: false,
      countdownTime: 2000,
      messageType: 'warn',
      content: '',
      success: () => {},
      show: true,
      imgObj: {
        warn: require('assets/images/4ede4d9de724fe9d5ed0107476b4a2e8.png'),
        success: require('assets/images/success-circle-a06e60880500901663e4ff8f1e13a75b.png'),
      },
    };
  },
  created() {
    if (!this.isNeedAutoDisappear) return;
    setTimeout(() => {
      this.show = false;
      this.success();
    }, this.countdownTime);
  },
};
</script>

<style lang="less" src="styles/pages/visit/widgets/message.less"></style>
